import { pageInfoEvent, pageInitializedEvent, pageLoadCompletedEvent, useAnalyticsTrack } from '@chr/react-analytics';
import { useEffect } from 'react';

export type UseAnalyticsPageViewProps = {
  pageName: string;
  pagePath: string;
  siteName: string;
};  
export type UseAnalyticsPageView = (UseAnalyticsPageViewProps: UseAnalyticsPageViewProps) => void;

export const useAnalyticsPageView: UseAnalyticsPageView = ({ pageName, pagePath, siteName }: UseAnalyticsPageViewProps) => {
  const track = useAnalyticsTrack();
  useEffect(() => {
    const trackPageView = async () => {
      track(pageInitializedEvent());
        track(
          pageInfoEvent(
            {
              name: pageName,
              path: pagePath,
            },
            {
              name: siteName,
            },
          ),
        );
        track(pageLoadCompletedEvent());
      }
    trackPageView();
    },
    [
      pageName,
      pagePath,
      siteName,
    ],
  );
};